import ApiService from './ApiService.js';
 
var ReportService = {

    getList: function($opts)
    {
       return new Promise(function(resolve,reject) {
            var $options = {};
            $options.url = 'dropDown?options='+JSON.stringify($opts)
            $options.method="get"
            ApiService.request($options)
                .then(response => {
                    console.log(response)
                    resolve(response.data.data)
                }).catch(error =>{
                    reject(error)
                })

       });
    },
    getReportLookup: function($opts)
    {
       return new Promise(function(resolve,reject) {
            var $options = {};
            $options.url = 'dropDown?options='+JSON.stringify($opts)
            $options.method="get"
            ApiService.request($options)
                .then(response => {
                    console.log(response)
                    resolve(response.data.data)
                }).catch(error =>{
                    reject(error)
                })

       });
    }
};
export default ReportService;